import { useState, useEffect } from 'react';

import { searchConfig } from '../config/searchConfig';

/**
 * Hook que detecta si el viewport es mobile (por defecto < `mobileBreakpoint`).
 * Usa window.matchMedia para escuchar cambios de tamaño.
 */
const useIsMobile = (
    breakpoint: number = searchConfig.mobileBreakpoint
): boolean => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia(
            `(max-width: ${breakpoint - 1}px)`
        );
        setIsMobile(mediaQuery.matches);

        const handler = (event: MediaQueryListEvent) => {
            setIsMobile(event.matches);
        };

        mediaQuery.addEventListener('change', handler);
        return () => mediaQuery.removeEventListener('change', handler);
    }, [breakpoint]);

    return isMobile;
};

export default useIsMobile;
